import { createBrowserRouter, RouterProvider, useOutletContext } from 'react-router-dom'
import App from './App'
import CaseManagement from './components/CaseManagement'
import Dashboard from './components/Dashboard'
import DocumentAnalysis from './components/DocumentAnalysis'
import HealthCheck from './components/HealthCheck'
import KnowledgeBase from './components/KnowledgeBase'
import PatentDatabaseComparisonManager from './components/PatentDatabaseComparisonManager'
import PatentSearch from './components/PatentSearch'
import RAGChat from './components/RAGChat'
import Reports from './components/Reports'
import Welcome from './components/Welcome'
import UserManagement from './components/admin/UserManagement'

// 包裝組件以傳遞用戶上下文
const DocumentAnalysisWrapper = () => {
  const { currentUser } = useOutletContext()
  return <DocumentAnalysis currentUser={currentUser} />
}

const PatentDatabaseComparisonWrapper = () => {
  const { currentUser } = useOutletContext()
  return <PatentDatabaseComparisonManager currentUser={currentUser} />
}

const CaseManagementWrapper = () => {
  const { currentUser } = useOutletContext()
  return <CaseManagement currentUser={currentUser} />
}

const UserManagementWrapper = () => {
  const { currentUser } = useOutletContext()
  // 權限檢查
  const hasPermission = (requiredRoles) => {
    if (!currentUser || !requiredRoles) return false
    return requiredRoles.includes(currentUser.role)
  }

  if (!hasPermission(['super_admin', 'admin', 'developer'])) {
    return <div className="p-6 text-center text-red-600">您沒有權限訪問此頁面</div>
  }

  return <UserManagement currentUser={currentUser} />
}

// 使用新的 createBrowserRouter API 來避免未來版本警告
const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        index: true,
        element: <Welcome />
      },
      {
        path: "welcome",
        element: <Welcome />
      },
      {
        path: "health",
        element: <HealthCheck />
      },
      {
        path: "dashboard",
        element: <Dashboard />
      },
      {
        path: "patent-search",
        element: <PatentSearch />
      },
      {
        path: "case-management",
        element: <CaseManagementWrapper />
      },
      {
        path: "document-analysis",
        element: <DocumentAnalysisWrapper />
      },
      {
        path: "patent-database-comparison",
        element: <PatentDatabaseComparisonWrapper />
      },
      {
        path: "reports",
        element: <Reports />
      },
      {
        path: "admin/users",
        element: <UserManagementWrapper />
      },
      {
        path: "knowledge-base",
        element: <KnowledgeBase />
      },
      {
        path: "rag-chat",
        element: <RAGChat />
      }
    ]
  }
], {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true,
    v7_fetcherPersist: true,
    v7_normalizeFormMethod: true,
    v7_partialHydration: true,
    v7_skipActionErrorRevalidation: true
  }
})

export default function AppRouter() {
  return (
    <RouterProvider
      router={router}
      future={{
        v7_startTransition: true
      }}
    />
  )
}
